<script lang="ts">
  import Loader from '../../../../custom/Loader.svelte'
  import { isShowLoader } from '../../store'
</script>

{#if $isShowLoader}
  <div class="flex justify-center">
    <Loader />
  </div>
{/if}